/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  removeFromNDCDetailsTableData,
  setNDCDetailsTableData,
} from '../../store/action';

const MoveToDetailsIconContainer = ({
  handleSingleMove,
  handleAllMove,
  handleAllRemove,
  handleSingleRemove,
  className = '',
  flexEnd = false,
}) => {
  const dispatch = useDispatch();

  return (
    <div
      className={`d-flex flex-column align-items-${
        flexEnd ? 'end' : 'center'
      } justify-content-center h-100 ${className}`}
    >
      {handleSingleMove && (
        <div
          tabIndex={0}
          className='round-icon-container'
          onClick={() => handleSingleMove()}
        >
          <i className='fa fa-light fa-caret-right' aria-hidden='true'></i>
        </div>
      )}
      {handleAllMove && (
        <div className='round-icon-container' tabIndex={0} onClick={() => handleAllMove()}>
          <i className='fa fa-light fa-step-forward' aria-hidden='true'></i>
        </div>
      )}

      <div
        className='round-icon-container'
        tabIndex={0}
        onClick={() => {
          if (handleAllRemove) {
            handleAllRemove();
          } else {
            dispatch(removeFromNDCDetailsTableData(true));
          }
        }}
      >
        <i className='fa fa-light fa-step-backward' aria-hidden='true'></i>
      </div>

      <div
        className='round-icon-container'
        tabIndex={0}
        onClick={() => {
          if (handleSingleRemove) {
            handleSingleRemove();
          } else {
            dispatch(removeFromNDCDetailsTableData());
          }
        }}
      >
        <i className='fa fa-light fa-caret-left' aria-hidden='true'></i>
      </div>
    </div>
  );
};

export default MoveToDetailsIconContainer;
